import React, { useState } from 'react'
import AddToWallet from './Components/AddToWallet'
import WalletPayment from './Components/WalletPayment'
import WalletSummary from './Components/WalletSummary'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'


function WalletCredits() {
  const[addToWallet,setAddToWallet]=useState(true)
  const[walletPayment,setWalletPayment]=useState(false)
  const[walletSummary,setWalletSummary]=useState(false) 
  const[topupAmount,setTopUpAmount]=useState("")
  const[retailerData,setRetailerData]=useState("")
  

  return (
    <div>

              <DashboardLayout>
              <DashboardNavbar />
              {walletPayment ? (
                  <WalletPayment  topupAmount={topupAmount} setWalletPage={setWalletPayment} Data={retailerData}/>
              ) : walletSummary ? (
                  <WalletSummary />
              ) : (
                  <AddToWallet  setWalletPage={setWalletPayment}   getTopupAmount={setTopUpAmount}  setRetailerData={setRetailerData}/>
              )}
                
             </DashboardLayout>
    </div>
  )
}

export default WalletCredits